import { DashboardState } from '../types';
import { FetchStateRequest } from './auth';

export const TRY_FETCH_STATE = 'TRY_FETCH_STATE';
export const TRY_CHANGE_ORG_FETCH_STATE = 'TRY_CHANGE_ORG_FETCH_STATE';
export const FETCH_STATE_SUCCESS = 'FETCH_STATE_SUCCESS';
export const CLEAR_STATE = 'CLEAR_STATE';

export interface FetchStateSuccessAction {
    type: typeof FETCH_STATE_SUCCESS;
    payload: DashboardState;
}

export interface TryFetchStateAction {
    type: typeof TRY_FETCH_STATE;
    payload: FetchStateRequest;
}

export interface TryChangeOrgFetchStateAction {
    type: typeof TRY_CHANGE_ORG_FETCH_STATE;
    payload: FetchStateRequest;
}

export interface ClearStateAction {
    type: typeof CLEAR_STATE;
}

export type FetchStateActionType = TryFetchStateAction | TryChangeOrgFetchStateAction;

export const tryFetchState: (request: FetchStateRequest) => TryFetchStateAction = (request) => {
    return {
        type: TRY_FETCH_STATE,
        payload: request,
    };
};

export const tryChangeOrgFetchState: (request: FetchStateRequest) => TryChangeOrgFetchStateAction = (request) => {
    return {
        type: TRY_CHANGE_ORG_FETCH_STATE,
        payload: request,
    };
};

export const fetchStateSuccess: (response: DashboardState) => FetchStateSuccessAction = (response) => {
    return {
        type: FETCH_STATE_SUCCESS,
        payload: response,
    };
};

export const clearState: () => ClearStateAction = () => {
    return {
        type: CLEAR_STATE,
    };
};
